import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Utils
import cookies from "../../../cookies/cookies";
// Constants
import apiClientConstants from "../../../../constants/api-client";
import storageConstants from "../../../../constants/storage";
// Handlers

var getAccessToken = function getAccessToken(channel) {
  return _defineProperty(_defineProperty(_defineProperty({}, apiClientConstants.CHANNELS.CC, cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN)), apiClientConstants.CHANNELS.OPS, cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN)), apiClientConstants.CHANNELS.WEB, cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN))[channel];
};
export { getAccessToken };